import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    if (!this.hasButtonTarget) return

    const isEnabled = this.inputTarget.value === "true"
    this.buttonTarget.classList.toggle("active", isEnabled)
    this.updateTooltip()
  }

  toggle() {
    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()
    this.buttonTarget.classList.toggle("active", !isEnabled)
    this.updateTooltip()
  }

  updateTooltip() {
    $(this.buttonTarget).tooltip('dispose').tooltip()
  }
}
